import { Center, Flex } from "@mantine/core";
import SubNavLinks from "../../Layout/SubNavLink/SubNavLinks";
import { client_selected, ILinkItem } from "../../client";
import { useAuth } from "../../context/auth";
import { ERole } from "../../interfaces/User/newUser";

export default function OperationPage({
  children,
}: {
  children: React.ReactNode;
}) {
  const { roleSelected } = useAuth();
  const isAnalytic = roleSelected === ERole.analyst;
  const isGenial = client_selected.name === "Genial";
  const isEmpiricus = client_selected.name === "Empiricus";

  const DATA_NAV_LINKS_GENIAL: ILinkItem[] = [
    {
      name: "global.routes_names.predictives",
      path: "/operacoes/predix",
    },
  ];

  const DATA_NAV_LINKS_ANALYST_EMPIRICUS: ILinkItem[] = [
    {
      name: "operacoes.performance_produto.title",
      path: "/operacoes/performance-produto",
    },
    { name: "operacoes.posicoes.title", path: "/operacoes/posicoes" },
    { name: "operacoes.ordens.title", path: "/operacoes/ordens" },
  ];

  const DATA_NAV_LINKS: ILinkItem[] = isGenial
    ? DATA_NAV_LINKS_GENIAL
    : isAnalytic
    ? isEmpiricus
      ? DATA_NAV_LINKS_ANALYST_EMPIRICUS
      : [
          { name: "operacoes.posicoes.title", path: "/operacoes/posicoes" },
          { name: "operacoes.ordens.title", path: "/operacoes/ordens" },
        ]
    : [
        {
          name: "operacoes.performance.title",
          path: "/operacoes/desempenho",
        },
        { name: "operacoes.posicoes.title", path: "/operacoes/posicoes" },
        { name: "operacoes.ordens.title", path: "/operacoes/ordens" },
      ];
  return (
    <>
      <Center bg="other.3">
        <Flex
          direction="column"
          w="100%"
          maw={1680}
          mx={{ base: 24, 768: 60 }}
          mb={180}
        >
          <Flex
            maw={{ base: "100%", 500: 670 }}
            gap={{ base: 12, 991: 16 }}
            h={{ base: 50, 500: 56 }}
            align="center"
            sx={{
              overflowY: "auto",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
              "::-webkit-scrollbar": {
                display: "none",
              },
            }}
          >
            <SubNavLinks item={DATA_NAV_LINKS} />
          </Flex>
        </Flex>
      </Center>
      <Center mt={-170}>
        <Flex
          mt={48}
          direction="column"
          w="100%"
          maw={1800}
          px={{ base: 24, 768: 60 }}
          sx={{ filter: " drop-shadow(0px 25px 35px rgba(0, 0, 0, 0.03))" }}
        >
          {children}
        </Flex>
      </Center>
    </>
  );
}
